import { Accordion } from "../global";
import { initSection } from "../utils";

document.addEventListener(
  "DOMContentLoaded",
  function () {
    if (document.body.dataset.suffix == "faq-new") {
      initSection("accordion-group", Accordion);
    }
  },
  false
);
